/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Point_0_TextInputs */

const en_visa_e2_point_0_text = /** @type {(inputs: Visa_E2_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We evaluate whether the client's business activity is better analyzed as a trade-based or investment-based case under the treaty framework.`)
};

const pt_visa_e2_point_0_text = /** @type {(inputs: Visa_E2_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliamos se a atividade comercial do cliente é melhor analisada como um caso baseado em comércio ou investimento sob a estrutura do tratado.`)
};

const es_visa_e2_point_0_text = /** @type {(inputs: Visa_E2_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluamos si la actividad comercial del cliente se analiza mejor como un caso basado en comercio o en inversión bajo el marco del tratado.`)
};

/**
* | output |
* | --- |
* | "We evaluate whether the client's business activity is better analyzed as a trade-based or investment-based case under the treaty framework." |
*
* @param {Visa_E2_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_point_0_text = /** @type {((inputs?: Visa_E2_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_point_0_text(inputs)
	if (locale === "es") return es_visa_e2_point_0_text(inputs)
	return en_visa_e2_point_0_text(inputs)
});